import * as types from './mutation-types'

const mutations = {
  [types.SET_SUBJECT](state, subject) {
    state.subject = subject
  },
  [types.SET_FILTERS](state, filters) {
    state.filters = filters
  },
  [types.SET_GRADES](state, grades) {
    state.grades = grades
  },
  [types.SET_SECTIONS](state, sections) {
    state.sections = sections
  },
  [types.SET_YEARS](state, years) {
    state.years = years
  },
  [types.SET_ORIGINS](state, origins) {
    state.origins = origins
  },
  [types.SET_SITECHOICES](state, siteChoices) {
    state.siteChoices = siteChoices
  },
  [types.SET_ALLRULES](state, allRules) {
    state.allRules = allRules
  },
  [types.SET_RESET](state, reset) {
    state.reset = reset
  },
  [types.SET_LOGINMODAL](state, loginModal) {
    state.loginModal = loginModal
  },
  [types.SET_USER](state, user) {
    state.user = user
  },
  [types.SET_USER_VERIFY](state, verify) {
    state.need_captcha = verify
  },
  [types.SET_USER_INFO](state, user) {
    state.user_info = user
  },
  [types.SET_COUPON](state, cou) {
    state.coupon = cou
  },
  [types.SET_XUEKECHOICE](state, xueke) {
    state.xuekeChoice = xueke
  },
  [types.SET_BINDACCOUNTS](state, accounts) {
    state.bindAccounts = accounts
  },
  [types.SET_PAYMODAL](state, data) {
    state.payModal = data
  },
  [types.SET_TIPMODAL](state, data) {
    state.tipModal = data
  },
  [types.SET_HANDOUTSHOW](state, data) {
    state.handoutShow = data
  }
}

export default mutations
